import { clearFilterParams } from '@btime/react-contexts'
import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { RefetchingIndicator } from '../../../components/helpers/StatePresenter'
import { useMultiSelectState } from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import { useOpenEditScreenKanbanColumnModal } from '../../../utils/routes/modals/modalsActions'
import CardsList from './CardsList'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import LazyLoad from '../../../packages/kiti/components/helpers/LazyLoad'
import Line from '../../../packages/kiti/components/helpers/Line'
import Panel from '../../../packages/kiti/components/structure/Panel'
import SelectAllCheckbox from '../../../packages/kiti/components/multiSelect/SelectAllCheckbox'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import Sticky from '../../../components/helpers/Sticky'
import Text from '../../../packages/kiti/components/presentation/Text'
import { useProcessesListById } from '../_load/ProcessesListById'
import DropdownLink from '../../../components/navigation/DropdownLink'
import { sortOptions } from '../../../containers/screens/kanban/helpers/SortHelper'

const ColumnPanel = ({ column, index, Card, Loader, sort, setSort, Counter, useGetAll = () => false }) => {
  const { isSelecting } = useMultiSelectState()
  const screen = useProcessesListById()
  const canEditScreen = useSessionPermission('setupScreen')
  const openEditModal = useOpenEditScreenKanbanColumnModal()
  const onSelectAll = useGetAll(column.filters)

  const filters = clearFilterParams(column?.filters || [])

  return (
    <LazyLoad>
      <Panel flex={1} bgColor="light1" noPadding maxHeight="90vh" minHeight="90vh" scroll>
        <Sticky zIndex={200}>
          <Separator weight={2} paddingH={0.8} bgColor="white" usePadding>
            <Grid gap={0.4} align="center">
              {isSelecting && (
                <Col>
                  <SelectAllCheckbox onSelectAll={onSelectAll} />
                </Col>
              )}

              <Col>
                <Text bold color="dark3">
                  {column.name}
                </Text>
              </Col>
              <Col>
                {Counter && <Counter filters={filters} />}
                <RefetchingIndicator />
              </Col>
              <Col>
                <DropdownLink
                  fromRight={column?.name?.length >= 15}
                  fromLeft={column?.name?.length < 15}
                  actionContent={<Icon name="BsArrowDownUp" color="dark3" size={0.7} />}
                  options={sortOptions(sort, setSort)}
                />
              </Col>
              <Col flex={1} />
              {canEditScreen && (
                <Icon
                  name="BsPencil"
                  color="dark3"
                  size={0.7}
                  onClick={() => openEditModal({ id: screen.id, index })}
                />
              )}
              {canEditScreen && (
                <Icon
                  name="BsLayers"
                  color="dark3"
                  size={0.7}
                  onClick={() => openEditModal({ id: screen.id, index, isCloning: true })}
                />
              )}
            </Grid>
          </Separator>

          <div>
            <Line color={column.color} height={0.2} />
          </div>
        </Sticky>

        <Separator weight={3} noMarginBottom flex={1}>
          {Loader && (
            <Loader columnFilters={column.filters} sort={sort}>
              <CardsList Card={Card} Loader={Loader} />
            </Loader>
          )}
        </Separator>
      </Panel>
    </LazyLoad>
  )
}

export default ColumnPanel
